import {gql} from "@apollo/client";
import { client } from "graphql/client";

export const HANDLE_TRANSFER_IN_OUT_FOR_DELIVERY = gql`
  mutation DeliveryMutation($input: OutForDeliveryInput!) {
    result: handleTransferInOutForDeliveryEvent(input: $input) {
        success
    }
  }
`;

interface OutForDeliveryInput {
    orderId: string;
    location: {
        latitude: number;
        longitude: number;
    };
}

export interface OutForDeliveryVariables {
    input: OutForDeliveryInput;
}

interface OutForDeliveryResponse {
    result: {
        success: boolean;
    };
}

export const handleTransferInOutForDeliveryEvent = async (input: OutForDeliveryInput): Promise<boolean>  => {
    const { data } = await client.mutate<OutForDeliveryResponse, OutForDeliveryVariables>({
        mutation: HANDLE_TRANSFER_IN_OUT_FOR_DELIVERY,
        variables: { input },
    });
    return data?.result?.success || false;
};  